import React, { useEffect, useState, useContext } from 'react';
import { useHistory } from 'react-router-dom';
import TopNavCustom from 'components/TopNav/TopNavCustom';
import Button from '@material-ui/core/Button';
import ListItem from '@material-ui/core/ListItem';
import List from '@material-ui/core/List';
import { SEARCH_JOB_TRIAL_FILTER } from '../../config/constants';
import styles from './../SearchJob/styles.module.scss';
import { useQuery, useQueryClient } from 'react-query';
import * as searchApi from 'api/search';
import FormDialogJob from '../../components/Jobs/FormDialogJob';
import {  MuiThemeProvider } from '@material-ui/core';
import { Col, Row } from 'antd';
import { getAllTagJobs } from '../../api/tag';
import {
  getLocalStorage,
  removeLocalStorage,
  serializeFormData,
  setLocalStorage,
  textFooterEnv,
} from '../../utils/utils';
import { useSelector } from 'react-redux';
import './style.css';
import { getAllItemJobResource } from 'api/itemJobResources';
import RenderSearchBoxElement from '../../components/Jobs/IconItemJob/RenderSearchBoxElement.js';
import { getAllStateForJob } from '../../api/itemJobResources';
// import { Helmet } from "react-helmet-async";
import Helmet  from "react-helmet";
import RenderSvgIcon from '../../components/RenderSvgIcon';
import { AppContext } from '../../context/AppContext';
import { customThemeTableSearch } from '../../themeMui/customer-table-search';


const wrapStyleIcon1 = {
  width: 17,
  height: 17,
  fill: 'currentColor',
  alignSelf: 'center',
  transition: 'fill 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
};


const styleWrapInline = {
  display: 'inline-block',
};

const styleWrap = {
  fontSize: '95%',
  fontColor: 'var(--emperor)',
  fontFamily: '"Times New Roman", Times, serif, ヒラギノ角ゴ ProN',
};

const dataPayload = {
  items: {},
  jobTags: [],
  state: null,
  area: null,
  itemRange: {},
};

const dataPayloadText = {
  area: null,
}

const dataHumburgerCustom = [
  {
    content: "ログイン",
    displayOrder: 1,
    displaySetting: 0,
    iconImage: "assets/image-icon/SVG_bookmark.svg",
    link: `${process.env.RAZZLE_PUBLIC_URL}/login/`
  },
  {
    content: "会員登録",
    displayOrder: 2,
    displaySetting: 0,
    iconImage: "assets/image-icon/SVG_create.svg",
    link: `${process.env.RAZZLE_PUBLIC_URL}/pre-register-job`
  },
  {
    content: "企業様はこちら",
    displayOrder: 3,
    displaySetting: 0,
    iconImage: "assets/image-icon/SVG_locate.svg",
    link: "/"
  }
]

function Index() {
  const appContext = useContext(AppContext);
  const history = useHistory();
  const queryClient = useQueryClient();
  const envInfoList = useSelector((state) => state.envInfo.data);
  const [listStateJobs, setListStateJobs] = useState([]);
  const [title, setTitle] = useState();
  const [valueObj, setValueObj] = useState(dataPayload);
  const [valueTextObj, setTextValueObj] = useState(dataPayloadText);
  const [minimumSalary, setMinimumSalary] = useState();

  useEffect(() => {
    const fetchLocalStorage = async () => {
      const dataRaw = await getLocalStorage(SEARCH_JOB_TRIAL_FILTER);
      if (dataRaw) {
        try {
          const data = JSON.parse(dataRaw);
          if (data) {
            setValueObj(Object.assign({}, {
              ...dataPayload,
              ...data,
              ...data?.stateId && { state: data.stateId },
              ...data?.areaId && { area: data.areaId },
            }));
          }
          if (data?.minimumSalary) {
            setMinimumSalary(data.minimumSalary)
          }
          if (data?.title) {
            setTitle(data.title)
          }
        } catch (e) {
          // Todo
        }

      }
    };

    fetchLocalStorage();
  }, []);

  // const [isLogin, setIsLogin] = useState(false);
  const [resourceTagJobs, setResourceTagJobs] = useState([]);
  const resultAllTagJobs = useQuery('getAllTagJobs', getAllTagJobs, { cacheTime: Infinity });
  const { data: itemJobResources } = useQuery(['itemJobResource'], () => getAllItemJobResource(), { cacheTime: Infinity });
  const { data: listStateJob } = useQuery('listStateJob', getAllStateForJob, { cacheTime: Infinity });
  const listEnvInfo = appContext.listEnvInfo;
  const isAuthenticated = appContext.isAuthenticated

  useEffect(() => {
    if (resultAllTagJobs?.data) {
      setResourceTagJobs((resultAllTagJobs?.data?.data ?? []));
    }
  }, [resultAllTagJobs]);

  useEffect(() => {
    if (listStateJob?.data) {
      setListStateJobs((listStateJob?.data ?? []));
    }
  }, [listStateJob]);

  const textFooter = () => {
    return textFooterEnv(envInfoList ?? []);
  };

  const handleClearSearch = async () => {
    setValueObj(dataPayload);
    setTextValueObj(dataPayloadText);
    setMinimumSalary('');
    setTitle("");
    await removeLocalStorage(SEARCH_JOB_TRIAL_FILTER);
  };

  const handleSearchJob = async () => {
    if (valueObj?.items) {
      for (let key in valueObj?.items) {
        if (Array.isArray(valueObj?.items[key])) {
          if (!valueObj?.items[key].length) {
            delete valueObj?.items[key];
          }
        }
      }
    }

    const data = {
      ...valueObj?.jobTags && valueObj?.jobTags.length && { jobTags: valueObj.jobTags },
      ...valueObj?.items && Object.keys(valueObj?.items).length && { items: valueObj.items },
      ...valueObj?.itemRange && Object.keys(valueObj?.itemRange).length && { itemRange: valueObj.itemRange },
      ...valueObj?.state && valueObj?.state.length && { stateId: valueObj.state },
      ...valueObj?.area && valueObj?.area.length && { areaId: valueObj.area },
      ...minimumSalary && {minimumSalary},
      ...title && {title},
    };
    await setLocalStorage(SEARCH_JOB_TRIAL_FILTER, JSON.stringify(data));

    try {
      // const { data: userSearchList, message } = await searchApi.searchJob(data);

      // Set data to query data after fetch api
      // queryClient.setQueryData('jobSearchJobTrialList', userSearchList);
      // queryClient.setQueryData('jobSearchJobTrialListMessage', message);

      let sd = {
        ...data.itemRange && { itemRange: JSON.stringify(data.itemRange) }, // []
        ...data.jobTags && { jobTags: JSON.stringify(data.jobTags) }, // []
        ...data.items && { items: JSON.stringify(data.items) }, // []
        ...data.areaId && { areaId: JSON.stringify(data.areaId) }, // []
        ...data.stateId && { stateId: JSON.stringify(data.stateId) }, // []
        ...data.minimumSalary && { minimumSalary: data.minimumSalary },
        ...data.title && { title: data.title }, // string
      };

      history.push({ pathname: `${process.env.RAZZLE_PUBLIC_URL}/search-job-trial-result`, search: `?${serializeFormData(sd)}` });
    } catch (e) {
      console.error(e.response?.data?.message);
    }
  };

  const onchangeData = (data, name, k) => {
    if (name) {
      setValueObj({ ...valueObj, [name]: data });
      setTextValueObj({ ...valueTextObj, [name]: k });

      if (name === 'state') {
        // Remove data area when state change
        setValueObj({ ...valueObj, [name]: data, area: null });
        setTextValueObj({ ...valueTextObj, [name]: k, area: null });
      }
    }
  };

  const onchangeDataItems = (data, name, k) => {
    if (name) {
      setValueObj({ ...valueObj, items: { ...valueObj.items, [name]: data } });
    }
  };

  const onchangeDataItemRange = (data, name, k) => {
    if (name) {
      setValueObj({ ...valueObj, itemRange: { ...valueObj.itemRange, [name]: data } });
    }
  };

  const showValueTexts = (key = '') => {
    let dataKeys = valueObj[key] ?? [];

    return resourceTagJobs.filter((item) => dataKeys.includes(item.id))
      .map(ele => `<span class="d-symbol-search">${ele.label}</span>`)
      .join('');
  };

  const showValueText = (key = '') => {
    let dataKey = valueObj[key] ?? {};

    if (key === 'state') {
      return listStateJobs?.filter((state) => !! state?.label).find((item) => item.id === dataKey)?.label;
    }

    if (key === 'area') {
      return typeof valueTextObj?.area === 'object' && valueTextObj?.area !== null
        ? Object.values(valueTextObj?.area).join('')
        // ? Object.values(valueTextObj?.area).map(ele => `<span class="d-symbol-search">${ele}</span>`).join('')
        : valueTextObj?.area;
    }

    return '';
  };

  const topNavibarLogo = listEnvInfo?.find((item) => item.code === 'top_navibar_logo');

  return (
    <div style={{ overflow: 'auto', height: '100vh', maxWidth: 560, margin: 'auto' }}>
      <Helmet prioritizeSeoTags>
        <meta name="description" content="モノリス-Job-LP" />
        <meta name="keywords" content="モノリス,仕事開発" />
        <meta name="author" content="群馬仕事" />
        <title>モノリス-Job-LP</title>
      </Helmet>
      <MuiThemeProvider theme={customThemeTableSearch}>
        <div className={styles.searchScreen}>
          <div className="wrapper-job-lp">
            <div>
              <div className={styles.topNavContainer}>
                <TopNavCustom name={'仕事TopPage'}
                              hasLogo={true}
                              hasHamburgerCustom={true}
                              dataHumburgerCustom={dataHumburgerCustom}
                              preventLogoClick={true} />
              </div>
              <div className={styles.listSelect}>
                <div className="wap-img-job-lp">
                  <img src="/contents_image_web/main_job.jpg" alt="job-lp" />
                  <a className="btn btn-short-link mr-10" href='/'>企業様はこちら</a>
                </div>
                <div className="align-center mb-heading mt-1">
                  <span className="stick-icon">&nbsp;</span>
                  <span className="title font-4">まずは検索</span>
                </div>
                <div>
                  <span className="title font-3">群馬の求人と求職者に特化した求人サイトです。<br /> アルバイト/バイト/パート/派遣の求人情報を探す</span>
                </div>

                <Row className="d-search-box">
                  <Col xs={12} style={{ padding: '4px 0 0 0' }}>
                    <div>
                      <ListItem className={`d-ant-col font-2`} style={{  padding: '4px 0 0px 0' }}>
                        <RenderSvgIcon name={'SVG_tag'} style={wrapStyleIcon1} />
                        <span style={styleWrap} className="font-2">キーワード検索/Search Words</span>
                      </ListItem>
                      <ListItem className={`d-ant-col font-2`} style={{ padding: "0 0 4px 0" }}>
                        <div className="d-item-box-search d-flex justify-content-center align-items-center">
                          <div className="d-range-left" style={{ width: '100%', position: 'relative' }}>
                            <input
                              name="title"
                              type="text"
                              style={{ width:'100%', minHeight: 32 }}
                              value={title}
                              onChange={(e) => setTitle(e.target.value)}
                              className={styles.inputSalary}
                              min={0}
                              placeholder='お好きなテキストを入力して下さい（例：日払い）'
                            />
                          </div>
                        </div>
                      </ListItem>
                    </div>
                  </Col>
                  <Col xs={12} style={{ padding: '4px 0 0 0' }} className="d-ant-col">
                    <RenderSvgIcon name={'SVG_tag'} style={wrapStyleIcon1} />
                    <span style={styleWrap} className="font-2">都道府県検索/Prefecture</span>
                  </Col>
                  <Col xs={12} className="d-flex justify-content-center" style={{ padding: '1px 0 4px' }}>
                    <div className="d-item-box-search">
                      <FormDialogJob
                        values={valueObj.state}
                        namelabel={'都道府県検索'}
                        nametext="state"
                        resource={listStateJobs?.filter((state) => !! state?.label)}
                        onchangeData={(e, name, k) => onchangeData(e, name, k)}
                        text={showValueText('state')}
                      />
                    </div>
                  </Col>

                  <Col xs={12} style={{ padding: '4px 0 0 0' }} className="d-ant-col">
                    <RenderSvgIcon name={'SVG_create'} style={wrapStyleIcon1} />
                    <span style={styleWrap} className="font-2">エリア検索/Area</span>
                  </Col>
                  <Col xs={12} className="d-flex justify-content-center" style={{ padding: '1px 0 4px' }}>
                    <div className="d-item-box-search">
                      <FormDialogJob
                        values={valueObj.area}
                        namelabel={'エリア検索'}
                        nametext="area"
                        userState={valueObj.state}
                        resource={[]}
                        onchangeData={(e, name, k) => onchangeData(e, name, k)}
                        text={showValueText('area')}
                        setTextValueObj={setTextValueObj}
                        valueTextObj={valueTextObj}
                      />
                    </div>
                  </Col>
                  <Col xs={12} style={{ padding: '4px 0 0 0' }}>
                    <div>
                      <ListItem className={`d-ant-col font-2`} style={{  padding: '4px 0 0px 0' }}>
                        <RenderSvgIcon name={'SVG_ring'} style={wrapStyleIcon1} />
                        <span style={styleWrap} className="font-2">給与額/Salary</span>
                      </ListItem>
                      <ListItem className={`d-ant-col font-2`} style={{ padding: "0 0 4px 0" }}>
                        <div className="d-item-box-search d-flex justify-content-center align-items-center">
                          <div className="d-range-left" style={{ width: '88%', position: 'relative' }}>
                            <input
                              name="minimum_salary"
                              type="number"
                              style={{ width:'100%', minHeight: 32 }}
                              value={minimumSalary}
                              onChange={(e) => setMinimumSalary(e.target.value)}
                              className={styles.inputSalary}
                              min={0}
                              placeholder='金額を入力して下さい'
                            />
                          </div>
                          <span style={{ paddingLeft: 10 }}>円以上</span>
                        </div>
                      </ListItem>
                    </div>
                  </Col>
                  {/* Render Search Box Element */}
                  <RenderSearchBoxElement itemJobResources={itemJobResources?.data ?? []}
                                          onchangeDataItems={onchangeDataItems}
                                          onchangeDataItemRange={onchangeDataItemRange}
                                          valueObj={valueObj}
                                          option={{ icon: true }}
                                          styles={styles}
                  />

                  <Col xs={12} style={{ padding: '3px 0 0 0' }} className="d-ant-col">
                    <RenderSvgIcon name={'SVG_ring'} style={wrapStyleIcon1} />
                    <span style={styleWrap} className="font-2">
                      仕事タグ/#Hashtag
                    </span>
                  </Col>
                  <Col xs={12} style={{ display: 'flex', justifyContent: 'center', padding: '1px 0 4px' }}>
                    <div style={(styleWrapInline, {
                      position: 'relative',
                      width: '100%',
                      marginRight: '18px',
                      marginLeft: '18px',
                    })}>
                      <FormDialogJob
                        values={valueObj?.jobTags}
                        namelabel={'仕事タグ'}
                        nametext="jobTags"
                        multi={true}
                        resource={resourceTagJobs}
                        onchangeData={(e, name, k) => onchangeData(e, name, k)}
                        text={showValueTexts('jobTags')}
                      />
                    </div>
                  </Col>
                </Row>
                <div className='wrapper-list-search-box-custom'>
                  <List>
                    <ListItem className={`d-ant-col font-2`} alignItems="flex-start" style={{ paddingLeft: 0, paddingRight: 0 }}>
                      <div
                        style={{
                          display: 'flex',
                          justifyContent: 'space-around',
                          bottom: 56,
                          margin: 'auto',
                          width: '100%',
                          padding: '8px 0',
                          maxWidth: '560px',
                        }}
                      >
                        <Button className="btn btn-main" variant="contained" onClick={handleSearchJob}>
                          <span>検索する</span>
                        </Button>
                        <Button className="btn btn-sub" variant="contained" onClick={handleClearSearch}>
                          <span >クリア</span>
                        </Button>
                      </div>
                    </ListItem>
                  </List>
                </div>
                <footer className="footer">
                  <div className="footer__inner">

                    <div className="footer__flex">
                      <div className="footer__flex__item">
                        <div className="footer__list">
                          <a className="footer__list__item"
                             href={`${process.env.RAZZLE_PUBLIC_URL}/pre-register-job`}>新規登録（仕事）</a>
                          <a className="footer__list__item"
                             href={`${process.env.RAZZLE_PUBLIC_URL}/login`}>会員ログインはこちら</a>
                          <a className="footer__list__item"
                             href="/contact_sales">資料請求（仕事）</a>
                          <a className="footer__list__item"
                             href={`${process.env.RAZZLE_PUBLIC_URL}/contactnologin`}>お問い合わせ</a>
                          <a className="footer__list__item"
                             href="/text/transaction_web_frame.html"
                             target="new">特定商取引法表記</a>
                          <a className="footer__list__item"
                             href="/text/terms_web_frame.html"
                             target="new">利用規約</a>
                          <a className="footer__list__item"
                             href="/text/privacy_web_frame.html"
                             target="new">プライバシーポリシー</a>
                        </div>
                        <div className="footer__share">
                          <a className="footer__share__item" href="/"><img
                            src={require('assets/image-icon/instagram.png')} alt="" /></a>
                          <a className="footer__share__item" href="/"><img
                            src={require('assets/image-icon/facebook.png')} alt="" /></a>
                          <a className="footer__share__item" href="/"><img
                            src={require('assets/image-icon/twitter.png')} alt="" /></a>
                        </div>
                      </div>
                    </div>
                  </div>
                </footer>
              </div>


              <div style={{
                marginTop: 'auto',
                display: 'flex',
                justifyContent: 'center',
                textAlign: 'center',
                position: 'relative',
              }}>
                {topNavibarLogo && (
                  <div className={`d-box-logo`}
                       style={{ alignSelf: 'center', marginRight: 10, position: 'absolute', left: 10 }}>
                    <img width={100} src={topNavibarLogo?.content} alt="Contact" />
                  </div>
                )}
                <p style={{ color: 'var(--text3)' }} className="font-3"
                   dangerouslySetInnerHTML={{ __html: textFooter() }}></p>
              </div>
            </div>
          </div>
        </div>
      </MuiThemeProvider>
    </div>
  );
}

export default Index;
